import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '@2021重庆·我的新期待';
const baseUrl = '2021-your-wishes-for-chongqing-h5';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'known-people',
      name: `${baseUrl}-known-people`,
      component: () => import('./pages/KnownPeople.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'wish-rank',
      name: `${baseUrl}-wish-rank`,
      component: () => import('./pages/WishRank.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'media-focus',
      name: `${baseUrl}-media-focus`,
      component: () => import('./pages/MediaFocus.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'comments-with-tag',
      name: `${baseUrl}-comments-with-tag`,
      component: () => import('./pages/CommentListWithSpecificTag.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
